<template>
	<div>
		<el-table
		  v-loading="loading"
		  :data="list"
		  fit
		  :header-cell-style="{background:'#f5f5f5'}"
		  highlight-current-row
		  style="width: 100%;"
		>
		<el-table-column label="用户UID" width="100" show-overflow-tooltip align="center">
		  <template slot-scope="scope">
		    <span>{{scope.row.uid}}</span>
		  </template>
		</el-table-column>
		<el-table-column label="用户昵称" show-overflow-tooltip align="center">
		  <template slot-scope="scope">
		    <span>{{scope.row.nickname}}</span>
		  </template>
		</el-table-column>
		<el-table-column label="用户头像" width="100" show-overflow-tooltip align="center">
		  <template slot-scope="scope">
		    <img :src="scope.row.headimgurl" style="width: 50px;height: 50px;" alt="">
		  </template>
		</el-table-column>
		<el-table-column label="关注时间" show-overflow-tooltip align="center">
		  <template slot-scope="scope">
		    <span>{{scope.row.createTime}}</span>
		  </template>
		</el-table-column>
		<el-table-column label="操作" width="120" align="center">
			<template slot-scope="scope">
			  <el-button type="primary" :disabled="scope.row.guanzhu==true?true:false" @click="user_guanzhu(scope.row)" size="mini">
				  {{scope.row.guanzhu==true?'已关注':'关注TA'}}
			  </el-button>
			</template>
		</el-table-column>
		</el-table>

		<div class="pagination-container" style="margin-top: 20px;">
		  <el-pagination
		    :current-page="listquery.page"
		    :page-sizes="[10,20,30, 40]"
		    :page-size="listquery.limit"
		    :total="total"
		    background layout="total, sizes, prev, pager, next, jumper"
		    @size-change="handleSizeChanges"
		    @current-change="handleCurrentChanges"
		  />
		</div>
	</div>
</template>

<script>
	import { user_woguanzhu_list,user_guanzhu } from "@/api/user"
	export default {
		data(){
			return{
				listquery:{
					page:1,
					limit:10,
				},
				total:0,
				list:[],
				loading:false
			}
		},
		props:{
			name:{
				type:String,
				default:'0'
			}
			
		},
		watch:{
			name(e){
				if(e=='nice'){
					this.listquery.page = 1
					this.user_woguanzhu_list();
				}
			}
		},
		mounted(){
			
		},
		methods:{
			user_woguanzhu_list(){
				this.loading = true
				user_woguanzhu_list(this.listquery).then(res=>{
					this.loading = false
					console.log("关注列表",res.data);
					this.total = res.data.total
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			handleSizeChanges(val){
				this.listquery.limit = 1
				this.user_woguanzhu_list();
			},
			handleCurrentChanges(val){
				this.listquery.page = 1
				this.user_woguanzhu_list();
			},
			user_guanzhu(row){
				if(row.guanzhu==true){
					return;
				}
				const loading = this.$loading({
				  lock: true,
				  text: '操作中',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				user_guanzhu({
					uid:row.puid
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
					this.user_woguanzhu_list();
				}).catch(()=>{
					loading.close();
				})
			},
		},
	}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/new/guanzhuwo.vue